import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "flag",
  "use": "flag-usage",
  "viewBox": "0 0 20 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 14\" id=\"flag\"><defs><rect id=\"flag_a\" width=\"20\" height=\"14\" rx=\"1.429\" /></defs><g fill=\"none\" fill-rule=\"evenodd\"><mask id=\"flag_b\" fill=\"#fff\"><use xlink:href=\"#flag_a\" /></mask><use xlink:href=\"#flag_a\" fill=\"#FFF\" /><path fill=\"#156DD1\" d=\"M0 0h20v7.467H0z\" mask=\"url(#flag_b)\" /><path fill=\"#FFD948\" d=\"M0 7.467h20V14H0z\" mask=\"url(#flag_b)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol